
<div class="profile-container">
  <div class="">
    <div class="profile-content">    
      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <div class="search">
              <form autocomplete="off" >
                <input type="text" (keyup.enter)="getObjectInfoByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter" placeholder="search">
              </form>
              <i class="bi bi-search" (click)="getObjectInfoByWildSearch()"></i>
            </div>
            <!-- <button data-toggle="modal" data-target="#deviceModal"><i class="bi bi-plus-lg"></i> Add</button> -->
            <div class="filter-icon">
              <!-- <i class="bi bi-funnel" title="Filter" (click)="toggleFilter()"></i> -->
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refresh()"></i>
            </div>
          </div>
        </div>
        <div class="row map-block">
          <div class="col-md-8 col-lg-8">
            <app-page-soon></app-page-soon>
          </div>

          <div class="col-md-4 col-lg-4" style="padding-left: 0;">
            <!-- <input type="text" placeholder="search" class="form-control"> -->
            <div class="customerList">
              <div class="list">
                <p *ngFor="let list of objectInfoList">{{list.givenName}}</p>
              </div>
              <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
              </div>

              <div class="loader" *ngIf="!isLoading && objectInfoList.length == 0">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>